import axios from 'axios'
import qs from 'qs'
import {getToken} from '@/util/authority'

const instance = axios.create({
  // timeout: 30000,
  // baseURL: process.env.VUE_APP_API_URL
  // baseURL: (process.env.NODE_ENV  != 'production' ? serverConfig.devURL: serverConfig.proURL) 
  baseURL: serverConfig.apiURL
})
// 文档中的统一设置post请求头。下面会说到post请求的几种'Content-Type'
instance.defaults.headers.post['Content-Type'] ='text/html; charset=utf-8'
instance.defaults.retry = 3; // 失败重新请求次数
axios.defaults.retryDelay = 200; // 重新请求间隔

let httpCode = {
  400: '请求参数错误',
  401: '权限不足, 请重新登录',
  403: '服务器拒绝本次访问',
  404: '请求资源未找到',
  500: '内部服务器错误',
  501: '服务器不支持该请求中使用的方法',
  502: '网关错误',
  504: '网关超时'
}

const handleError = (error) => {
  let tips = error.response.status in httpCode ? httpCode[error.response.status] : error.response.data.msg
}

/** 添加请求拦截器 **/
instance.interceptors.request.use(config => {
  config.headers['Authorization'] = "Bearer " + getToken()
  config.headers['Accept'] = '*/*'

  // 在这里：可以根据业务需求可以在发送请求之前做些什么:例如我这个是导出文件的接口，因为返回的是二进制流，所以需要设置请求响应类型为blob，就可以在此处设置。
  if (config.url.includes('pur/contract/export')) {
    config.headers['responseType'] = 'blob'
  }
  // 我这里是文件上传，发送的是二进制流，所以需要设置请求头的'Content-Type'
  if (config.url.includes('/upload') || config.url.includes('import')) {
    config.headers['Content-Type'] = 'multipart/form-data'
  }
  if (config.url.includes('/PictureMaterialManage')) {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  //config.headers['clientType'] = 'manage';

  return config
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error)
})

/** 添加响应拦截器  **/
instance.interceptors.response.use(response => {
   //debugger
  // loadingInstance.destroy()
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response)
  } else {
    // Message.error(response.data.message)
    return Promise.reject(response)
  }
}, error => {
  console.warn("error", error)
  // loadingInstance.destroy()
  if (error.response) { 
      handleError(error);
      return Promise.reject(error)   
  } else {
    Message.error('请求超时, 请刷新重试')
    return Promise.reject(new Error('请求超时, 请刷新重试'))
  }
})

// 文件流转blob对象下载
function downloadFile(data, type, fileName) {
  let blob = new Blob([data], {type: `application/${type};charset=utf-8`});
  // 获取heads中的filename文件名
  let downloadElement = document.createElement('a');
  // 创建下载的链接
  let href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  // 下载后文件名
  downloadElement.download = fileName;
  document.body.appendChild(downloadElement);
  // 点击下载
  downloadElement.click();
  // 下载完成移除元素
  document.body.removeChild(downloadElement);
  // 释放掉blob对象
  window.URL.revokeObjectURL(href);
}
// export default function download(url,data, method, headers, allowAnonymous) {
  export default function download(saveFileName='', url, params, config = {}) {
    let realUrl = url;
    return new Promise(resolve => {
      instance
        .request({
          method: 'get',
          url,
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params, { indices: false })
          },
          responseType: 'arraybuffer',
          ...config
        })
        // .request(requestCofig)
        .then(res => {
          let data = res.data
          let url = window.URL.createObjectURL(new Blob([data],{type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', saveFileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)    
            resolve(true);    
        })
        .catch(error => {
          resolve(error);
          return error;
        });
    });
  }